import React from 'react';
import { useSelector } from 'react-redux';
import { getDomainFromUrl } from '../../../utils';
import useTranslation from 'hooks/useTranslation';

const mapState = ({ websitesData }) => ({
  websites: websitesData.websites,
});
const InviteOperatorModalWebsites = ({
  selectedWebsiteIds,
  setSelectedWebsiteIds,
}) => {
  const { websites } = useSelector(mapState);
  const { getTranslation } = useTranslation('OPERATORS');
  const { t } = getTranslation();

  const handleWebsitesSelection = (event) => {
    const { id } = event.target;
    if (!selectedWebsiteIds.includes(id)) {
      addToSelectedIds(id);
      return;
    }
    removeFromSelectedIds(id);
  };

  const addToSelectedIds = (idToAdd) => {
    setSelectedWebsiteIds((prevSelectedIds) => [...prevSelectedIds, idToAdd]);
  };

  const removeFromSelectedIds = (idToRemove) => {
    const filteredWebsitesIds = selectedWebsiteIds.filter(
      (id) => id !== idToRemove
    );
    setSelectedWebsiteIds(filteredWebsitesIds);
  };

  return (
    <>
      <h5 className='modal__container__body__invite__form__title'>
        {t('OPERATOR_MODAL_WEBSITES_LIST_TITLE')}
      </h5>
      <div className='modal__container__body__invite__form__websitelist grid'>
        {websites.data &&
          websites.data.map((website) => {
            const { url, id } = website;
            const domain = getDomainFromUrl(url);
            return (
              <div
                key={domain}
                className='form-control modal__container__body__invite__form__websitelist__website flex flex-ai-c flex-jc-s'
              >
                <input
                  id={id}
                  name={id}
                  type='checkbox'
                  checked={
                    Array.isArray(selectedWebsiteIds) &&
                    selectedWebsiteIds.includes(id)
                      ? true
                      : false
                  }
                  onChange={(event) => handleWebsitesSelection(event)}
                />
                <label htmlFor={id} aria-describedby='label' title={domain}>
                  {domain}
                </label>
              </div>
            );
          })}
      </div>
    </>
  );
};

export default InviteOperatorModalWebsites;
